import React from 'react';
export var PfLink = function PfLink(_ref) {
  var href = _ref.href,
    onClick = _ref.onClick,
    id = _ref.id,
    _ref$popup = _ref.popup,
    popup = _ref$popup === void 0 ? true : _ref$popup,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("a", {
    href: href,
    id: id,
    rel: popup ? 'noreferrer noopener' : undefined,
    target: popup ? '_blank' : undefined,
    onClick: onClick
  }, children);
};